<template>
  <div class="content">
    <div class="top">
      <div class="header">
        <div class="back-btn" @click="lastStep">
          <van-icon name="arrow-left" color="#fff" />
          <span>返回</span>
        </div>
        <span class="title">个人信息</span>
      </div>
    </div>
    
    <div class="main">
      <div class="steps-card">
        <div class="tips">请正确填写预约信息，以确保预约成功</div>
        <div class="step-wrap">
          <div class="step-item active">
            <div class="num">1</div>
            <div class="text">预约事项</div>
          </div>
          <div class="line active"></div>
          <div class="step-item active">
            <div class="num">2</div>
            <div class="text">个人信息</div>
          </div>
          <div class="line"></div>
          <div class="step-item">
            <div class="num">3</div>
            <div class="text">预约时间</div>
          </div>
        </div>
      </div>
      
      <div class="business">
        <div class="business-item">
          <div style="height: 0.3rem;"></div>
          <div class="address">
            <img src="../assets/imgs/write.png">
            <div style="font-size: 0.4rem;color: #333;font-weight: bold;">请填写身份信息</div>
          </div>
          <div class="address-select">
            <van-form @submit="nextStep" ref="form">
              <van-field v-model="username" label="姓名" label-width="1.8rem" placeholder="请输入姓名" label-class="field-text"
                :rules="nameRules" required clearable />
              <van-field v-model="displayIdcard" label="身份证号" label-width="1.8rem" placeholder="请输入身份证号"
                label-class="field-text" :rules="idcardRules" required clearable @input="handleIdcardInput" />
              <van-field v-model="displayPhone" type="tel" label="手机号" label-width="1.8rem" placeholder="请输入手机号"
                label-class="field-text" :rules="phoneRules" required clearable @input="handlePhoneInput" />
            </van-form>
          </div>
        </div>
      </div>
    </div>
    
    <div class="bottom">
      <div class="laststep" @click="lastStep">上一步</div>
      <div class="nextstep" @click="nextStep">下一步</div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue';
import { Form, Field, Divider, Dialog } from 'vant';
import { checkCanReserve } from '../utils/cancelLimitHelper.js';

Vue.use(Form);
Vue.use(Field);
Vue.use(Divider);

export default {
  data() {
    return {
      centerguid: '',
      tasktypeguid: '',
      tasktypename: '',
      centerName: '',
      projectText: '',
      username: '',
      idcard: '', // 完整的身份证号
      phone: '', // 完整的手机号
      displayIdcard: '', // 用于显示的脱敏身份证号
      displayPhone: '', // 用于显示的脱敏手机号
      nameRules: [
        { required: true, trigger: "onBlur" },
        {
          validator: (value) => {
            return /^[\u4e00-\u9fa5]{2,5}$/.test(value);
          },
          message: "请输入中文",
          trigger: "onBlur",
        }],
      idcardRules: [
        { required: true, trigger: "onBlur" },
        {
          validator: (value) => {
            // 验证时使用完整的身份证号，而不是脱敏后的显示值
            const actualValue = value.includes('*') ? this.idcard : value;
            return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(actualValue);
          },
          message: "身份证号码格式错误",
          trigger: "onBlur",
        }],
      phoneRules: [
        { required: true, trigger: "onBlur" },
        {
          validator: (value) => {
            // 验证时使用完整的手机号，而不是脱敏后的显示值
            const actualValue = value.includes('*') ? this.phone : value;
            return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(actualValue);
          },
          message: "手机号格式错误",
          trigger: "onBlur",
        }],
    }
  },

  methods: {
    // 身份证脱敏显示
    maskIdcard(idcard) {
      if (!idcard || idcard.length < 10) return idcard;
      // 保留前6位和后4位，中间用*代替
      return idcard.substring(0, 6) + '******' + idcard.substring(idcard.length - 4);
    },
    // 手机号脱敏显示
    maskPhone(phone) {
      if (!phone || phone.length < 11) return phone;
      // 保留前3位和后4位，中间用*代替
      return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
    },
    // 处理身份证号输入
    handleIdcardInput(value) {
      // 如果输入的不包含*，说明是用户正在输入新的身份证号
      if (value && !value.includes('*')) {
        this.idcard = value;
        this.displayIdcard = value;
      } else if (!value) {
        // 清空
        this.idcard = '';
        this.displayIdcard = '';
      }
      // 如果包含*，说明是脱敏显示，不做处理
    },
    // 处理手机号输入
    handlePhoneInput(value) {
      // 如果输入的不包含*，说明是用户正在输入新的手机号
      if (value && !value.includes('*')) {
        this.phone = value;
        this.displayPhone = value;
      } else if (!value) {
        // 清空
        this.phone = '';
        this.displayPhone = '';
      }
      // 如果包含*，说明是脱敏显示，不做处理
    },
    // 检查预约限制
    checkReserveLimit() {
      if (!this.idcard) return;
      
      const checkResult = checkCanReserve(this.idcard);
      if (!checkResult.canReserve) {
        Dialog.alert({
          title: '无法预约',
          message: checkResult.message,
          confirmButtonText: '我知道了'
        }).then(() => {
          // 返回上一步
          this.lastStep();
        });
      }
    },
    nextStep() {
      this.$refs.form.validate().then(() => {
        console.log('表单校验通过');
        
        // 在跳转前检查预约限制（使用完整的身份证号）
        const checkResult = checkCanReserve(this.idcard);
        if (!checkResult.canReserve) {
          Dialog.alert({
            title: '无法预约',
            message: checkResult.message,
            confirmButtonText: '我知道了'
          });
          return;
        }
        
        // 跳转到预约时间页面（使用完整的身份证号和手机号）
        this.$router.push({
          name: 'subscribeTime', query: {
            username: this.username,
            idcard: this.idcard, // 传递完整的身份证号
            phone: this.phone, // 传递完整的手机号
            areaCode: this.$route.query.areaCode,
            centerName: this.$route.query.centerName,
            deptId: this.$route.query.deptId,
            deptName: this.$route.query.deptName,
            tasktypeguid: this.$route.query.tasktypeguid,
            projectText: this.$route.query.projectText,
            projectNo: this.$route.query.projectNo,
            subscribeMode: this.$route.query.subscribeMode,
            from: this.$route.query.from
          }
        });

      }).catch(() => {
        console.log('表单校验不通过');
      });
    },
    lastStep() {
      // 使用replace返回，避免历史记录堆积（使用完整的身份证号和手机号）
      this.$router.replace({
        name: 'subscribeProject', query: {
          username: this.username,
          idcard: this.idcard, // 传递完整的身份证号
          phone: this.phone, // 传递完整的手机号
          areaCode: this.$route.query.areaCode,
          centerName: this.$route.query.centerName,
          deptId: this.$route.query.deptId,
          deptName: this.$route.query.deptName,
          tasktypeguid: this.$route.query.tasktypeguid,
          projectText: this.$route.query.projectText,
          projectNo: this.$route.query.projectNo,
          subscribeMode: this.$route.query.subscribeMode,
          from: this.$route.query.from
        }
      });
    },
  },
  created() {
    // 优先从路由参数获取（从上一步或下一步返回时保持数据）
    this.username = this.$route.query.username;
    this.idcard = this.$route.query.idcard;
    this.phone = this.$route.query.phone;

    console.log('=== 预约页面初始化 ===');
    console.log('路由参数:', {
      username: this.$route.query.username,
      idcard: this.$route.query.idcard,
      phone: this.$route.query.phone
    });

    // 如果路由参数没有，则从登录信息中自动填充（只读取小写的idcard）
    if (!this.username) {
      this.username = localStorage.getItem('nickName') || '';
      console.log('从localStorage读取nickName:', this.username);
    }
    if (!this.idcard) {
      const idCardFromStorage = localStorage.getItem('idcard') || '';
      this.idcard = idCardFromStorage;
      console.log('从localStorage读取idcard:', this.idcard);
    }
    if (!this.phone) {
      this.phone = localStorage.getItem('phonenumber') || '';
      console.log('从localStorage读取phonenumber:', this.phone);
    }

    // 设置脱敏显示
    this.displayIdcard = this.idcard ? this.maskIdcard(this.idcard) : '';
    this.displayPhone = this.phone ? this.maskPhone(this.phone) : '';

    console.log('最终填充的数据:', {
      username: this.username,
      idcard: this.idcard,
      phone: this.phone,
      displayIdcard: this.displayIdcard,
      displayPhone: this.displayPhone
    });

    // 如果已有身份证号，检查预约限制
    if (this.idcard) {
      this.$nextTick(() => {
        this.checkReserveLimit();
      });
    }

    //回填
    // this.tasktypename = this.$route.query.tasktypename;
    // this.projectText = this.$route.query.projectText;
  },
  beforeDestroy() {

  },
}
</script>


<style lang="scss" scoped>
@import '../assets/style/person.scss';

::v-deep {
  .field-text {
    white-space: nowrap !important;
  }

  .van-icon {
    font-size: 0.36rem !important;
  }

  .van-divider {
    margin: 5px 0 !important;
  }

  .van-cell__title {
    span {
      display: block;
      text-align: justify !important;
      text-align-last: justify;
      width: 100%;
      color: #000;
    }
  }

  .van-field__control {
    text-indent: 0.5rem;
  }

}
</style>